module.exports = __webpack_public_path__ + "img/box_truck_h.6ffbfd8b.png";